import { render, staticRenderFns } from "./OurStory.vue?vue&type=template&id=71c746d4&scoped=true&"
import script from "./OurStory.vue?vue&type=script&lang=js&"
export * from "./OurStory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c746d4",
  null
  
)

export default component.exports